import { documentConstants } from "../constants";
import { documentService } from "../services";
import { loaderMaskActions } from ".";
import { handleErrors } from "../../utils";

export const documentActions = {
  getAll,
  getListFromFile,
  expandRow,
  setActiveRow,
  clearDocuments,
  resetDocuments,
  setDocumentListParams,
  toggleHiddenColumn,
  toggleShowColumnMenu,
  setHiddenColumn,

  getDownloadFile,

  toggleDownLoadSpinner,
  setDownloadFileParams,
  setEmailSent,
  setEmailFailedButDownloadReady,
  //setChannelParam,
};

function setEmailFailedButDownloadReady(emailDownloadFileParams) {
  return { type: documentConstants.SET_EMAIL_FAILED_BUT_DOWNLOAD_READY, emailDownloadFileParams };
}

function setEmailSent(emailSent) {
  return { type: documentConstants.SET_EMAIL_SENT, emailSent };
}

function setDownloadFileParams(downloadFileParams) {
  return { type: documentConstants.SET_DOWNLOAD_FILE_PARAMS, downloadFileParams };
}

function toggleDownLoadSpinner(showSpinner) {
  if(!showSpinner) {
    // clear all localStorage for downloadFile
    localStorage.setItem('downloadLoadingForFiles', '');
		localStorage.setItem('downloadLoadingForDocuments', '');
		localStorage.setItem('downloadPipelineId', '');
		localStorage.setItem('isSendingEmail', '');
		localStorage.setItem('downloadFileUserId', '');
  }
  return { type: documentConstants.TOGGLE_DOWNLOAD_SPINNER, showSpinner };
}

function setHiddenColumn(hiddenColumns) {
  return { type: documentConstants.SET_HIDDEN_COLUMNS, hiddenColumns };
}

function toggleHiddenColumn(column) {
  return { type: documentConstants.TOGGLE_HIDDEN_COLUMNS, column };
}

function toggleShowColumnMenu(column) {
  return { type: documentConstants.TOGGLE_SHOW_COLUMN_MENU, column };
}

function getDownloadFile(params) {
  return dispatch => {
    dispatch(request());
    return documentService.getAll(params).then(
      data => {
        return dispatch(success(data.Data, data.TotalPages));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(loaderMaskActions.hide(""));
        return dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: documentConstants.GET_DOWNLOAD_REQUEST };
  }
  function success(files, TotalPages) {
    return { type: documentConstants.GET_DOWNLOAD_SUCCESS, files, TotalPages };
  }
  function failure(error) {
    return { type: documentConstants.GETALL_FAILURE, error };
  }
}

function getAll(params, loadingText) {
  return dispatch => {
    dispatch(loaderMaskActions.show(loadingText || "Loading documents..."));
    dispatch(request());
    return documentService.getAll(params).then(
      data => {
        dispatch(loaderMaskActions.hide(""));
        return dispatch(success(data.Data.documents, data.TotalPages));
      },
      error => {
        handleErrors(error, dispatch);
        return dispatch(loaderMaskActions.hide(""));
        //dispatch(failure(error))
      }
    );
  };

  function request() {
    return { type: documentConstants.GETALL_REQUEST };
  }
  function success(documents, TotalPages) {
    return { type: documentConstants.GETALL_SUCCESS, documents, TotalPages };
  }
  //function failure(error) { return { type: documentConstants.GETALL_FAILURE, error } }
}

function getListFromFile(params, withUniqueId) {
  return dispatch => {
    dispatch(loaderMaskActions.show("Loading documents..."));
    documentService.getListFromFile(params).then(
      data => {
        dispatch(
          success(
            data.Data.documents,
            data.Data.filesummary,
            data.TotalPages,
            params,
            withUniqueId
          )
        );
        dispatch(loaderMaskActions.hide(""));
      },
      error => {
        handleErrors(error, dispatch);
        dispatch(failure(error));
        dispatch(loaderMaskActions.hide(""));
      }
    );
  };

  //function request() { return { type: documentConstants.GETALL_REQUEST } }
  function success(
    documents,
    filesummary,
    TotalPages,
    params,
    withUniqueId
  ) {
    return {
      type: documentConstants.GETLISTFROMFILE_SUCCESS,
      documents,
      TotalPages,
      params,
      filesummary,
      withUniqueId
    };
  }
  function failure(error) {
    return { type: documentConstants.GETALL_FAILURE, error };
  }
}

function expandRow(rowId) {
  return { type: documentConstants.EXPAND_ROW, rowId };
}

function setActiveRow(rowIndex) {
  return { type: documentConstants.SET_ACTIVE_ROW, rowIndex };
}

function setDocumentListParams(paramName, paramValue) {
  return { type: documentConstants.SET_DOC_LIST_PARAMS, paramName, paramValue };
}

function clearDocuments() {
  return { type: documentConstants.CLEAR_DOCUMENTS };
}

function resetDocuments() {
  return { type: documentConstants.RESET_DOCUMENTS };
}
